import EvalSelectThirdpartyUser from './src/main';

/* istanbul ignore next */
EvalSelectThirdpartyUser.install = function(Vue) {
  Vue.component(EvalSelectThirdpartyUser.name, EvalSelectThirdpartyUser);
};

export default EvalSelectThirdpartyUser;
